import React from 'react';
import { Card } from 'primereact/card';
import { Tag } from 'primereact/tag';
import { extractResponseData, SmartSection, NoRecordsCard, RawResponseButton } from './_SmartFieldRenderer';

// Generic output renderer used by ~25 simple Surepass reports — RERA, MCA,
// SE, Fuel, Esign Get-family, ITR Get/Download, Digilocker, Udyam, SMS, etc.
// Delegates all field/section/array rendering to `_SmartFieldRenderer` so the
// look stays in lock-step with Company Details / Equifax / TAN / GSTIN /
// Udyog Aadhar etc. — pure PrimeReact + PrimeFlex, no embedded <style>, no
// hex codes, no banned typography.

const GenericSurepassOutputComponent = ({
    reportData,
    title = 'Verification Report',
    icon = 'pi-check-circle',
    hideCredits,
    isSharedView,
}) => {
    const shouldHideCredits = hideCredits || isSharedView;
    const { responseData, remainingBalance, errorMsg, hasRealData } = extractResponseData(reportData);

    if (!reportData) {
        return <NoRecordsCard subtitle="No data available" />;
    }
    if (!responseData || !hasRealData) {
        return (
            <NoRecordsCard
                errorMsg={errorMsg}
                subtitle="No records found for the provided details. Please verify and try again."
            />
        );
    }

    return (
        <div>
            {/* Sub-header — h2 + remaining-credits Tag (matches Equifax / Company Details outputs) */}
            <div className="flex flex-column md:flex-row md:justify-content-between md:align-items-center gap-2 mb-3">
                <h2 className="text-lg font-semibold text-900 m-0">
                    <i className={`pi ${icon} mr-2 text-primary`} aria-hidden="true" />
                    {title}
                </h2>
                {!shouldHideCredits && remainingBalance !== undefined && (
                    <Tag
                        severity="success"
                        icon="pi pi-wallet"
                        value={`Remaining: ${remainingBalance}`}
                        className="text-sm"
                    />
                )}
            </div>

            <Card>
                <SmartSection data={responseData} icon={icon} title={null} />
                <RawResponseButton data={responseData} />
            </Card>
        </div>
    );
};

export default GenericSurepassOutputComponent;
